import { FC } from "react";
import { useLocation } from "react-router-dom";
import clsx from "classnames";
import { useStyles } from "./NavigationBar.style";
import { Icon } from "../../core/Icon/Icon";
import { PageRoutes } from "../../../constants/routes";
import { useCustomNavigate } from "@onmo/ui";

type GameDetailHeaderProps = {
  onClose?: () => void;
};

export const GameDetailHeader: FC<GameDetailHeaderProps> = (props) => {
  const { onClose } = props;
  const classes = useStyles();
  const location = useLocation();
  const { handleNavigateBack } = useCustomNavigate();

  const handleAutoScrollTop = () => {
    handleNavigateBack();
    window.scrollTo(0, 0);
  };

  if (location.pathname.startsWith(PageRoutes.GamePlay)) {
    return null;
  }

  return (
    <div
      className={clsx(
        classes.singleRoot,
        location.pathname !== PageRoutes.Paywall && classes.notAtTop,
      )}
    >
      <div
        className={classes.singleNav}
        onClick={onClose || handleAutoScrollTop}
        id="close-button"
        data-button-sound="back"
      >
        <Icon name={"icon-linear-arrow-left-3"} className={classes.iconSize} />
      </div>
    </div>
  );
};
